module.exports = __webpack_public_path__ + "img/Webpack.c438fa17.png";